<template>
  <table>
    <tbody>
      <tr v-for="(row, index) in rows" :key="index">
        <td>
          {{row.unit_number}},
          {{row.category}},
          {{row.slug}},
          {{row.area}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "example-component",
  data() {
    return {
      rows: []
    };
  },
  mounted() {
    this.propertyList();
  },
  methods: {
    propertyList: function() {
      let vm = this;
      this.$http
        .get("/listings")
        .then(response => {
          vm.rows = response.data.data;
        })
        .catch(error => {
          vm.rows = [];
          console.log(error);
          console.log("change page");
        });
    }
  }
};
</script>
